import React from "react";
import { Button, useDisclosure } from "@chakra-ui/react";
import { IoAdd } from "react-icons/io5";
import { Modal } from "components";
import { SelectionContext } from "../../../../duck";
import DisclaimerProcedureForm from "../form";
import { useAddDisclaimerProcedureSetting } from "./duck";

const Add: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { organizationSettingId } = React.useContext(SelectionContext);
  const onSubmit = useAddDisclaimerProcedureSetting(organizationSettingId);

  return (
    <>
      <Button onClick={onOpen} leftIcon={<IoAdd />}>
        Add
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Add Procedure type condition"
      >
        <DisclaimerProcedureForm
          onSubmit={values =>
            onSubmit(values).then(() => {
              onClose();
            })
          }
          onCancel={onClose}
        />
      </Modal>
    </>
  );
};

export default Add;
